import { Card, Col, Row } from "antd";
import React, { useEffect } from "react";
import { MyBreadcrumb, MyButton } from "../../../../components";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAppearByID } from "../../../../store/pages/printJournal/actions";
import { RootState } from "../../../../store";
import { selectStore } from "../../../../store/selector";
import { CardItemSpan, CardItemTitle } from "../index.style";
import { Document, HeadingLevel, Packer, Paragraph, TextRun } from "docx";
import { saveAs } from "file-saver";


export const AppealsView = React.memo(() => {
  const dispatch = useDispatch();

  const { id } = useParams()
  const {
    printJournal: {
      appealsOne
    }
  }: RootState = useSelector(selectStore)
  useEffect(() => {
    console.log("id", id)
    if (id) {
      dispatch(getAppearByID(id))
    }
  }, [id])

  const generateDoc = () => {
    const doc = new Document({
      sections: [
        {
          children: [
            new Paragraph({
              style:"margin-bottom: 16px",
              children: [
                new TextRun({
                  text: `${appealsOne?.data?.appeal?.student}`,
                  bold: true,
                  size: `${16}pt`
                })
              ]
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: `Дата:`,
                  bold: true,
                  size: `${16}pt`
                }),
                new TextRun({
                  text: ` ${appealsOne?.data?.appeal?.datetime_at}`,
                  size: `${16}pt`
                })
              ]
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: `Группа:`,
                  bold: true,
                  size: `${16}pt`
                }),
                new TextRun({
                  text: ` ${appealsOne?.data?.appeal?.group}`,
                  size: `${16}pt`
                })
              ]
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: `Причина:`,
                  bold: true,
                  size: `${16}pt`
                }),
                new TextRun({
                  text: ` ${appealsOne?.data?.appeal?.reason}`,
                  size: `${16}pt`
                })
              ]
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: `Описание:`,
                  bold: true,
                  size: `${16}pt`
                }),
                new TextRun({
                  text: ` ${appealsOne?.data?.appeal?.description}`,
                  size: `${16}pt`
                })
              ]
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: `Рекомендации:`,
                  bold: true,
                  size: `${16}pt`
                }),
                new TextRun({
                  text: ` ${appealsOne?.data?.appeal?.recommendation}`,
                  size: `${16}pt`
                })
              ]
            })
          ]
        }
      ]
    });

    Packer.toBlob(doc).then((blob) => {
      saveAs(blob, appealsOne?.data?.appeal?.student);
    });
  }
  return (
    <>
      <MyBreadcrumb isBack title="Карточка обращения студента" extra={(
        <Row gutter={[16, 16]} align='middle'>
          <Col>
            <MyButton onClick={() => generateDoc()}>Экспорт</MyButton>
          </Col>
        </Row>
      )} />
      <Row justify={'center'}>
        <Col span={20}>
          <Card title={appealsOne?.data?.appeal?.student} style={{ width: "100%" }} loading={appealsOne?.loading}>
            <CardItemTitle> Дата: <CardItemSpan>{appealsOne?.data?.appeal?.datetime_at}</CardItemSpan> </CardItemTitle>
            <CardItemTitle> Группа: <CardItemSpan>{appealsOne?.data?.appeal?.group}</CardItemSpan> </CardItemTitle>
            <CardItemTitle> Причина: <CardItemSpan>{appealsOne?.data?.appeal?.reason}</CardItemSpan> </CardItemTitle>
            <CardItemTitle> Описание: <CardItemSpan>{appealsOne?.data?.appeal?.description}</CardItemSpan> </CardItemTitle>
            <CardItemTitle> Рекомендации: <CardItemSpan>{appealsOne?.data?.appeal?.recommendation}</CardItemSpan> </CardItemTitle>
          </Card>
        </Col>
      </Row>
    </>

  )
})